import React from 'react';
import $ from 'jquery';

import PageCategoryTitle from './PageCategoryTitle';
import AuthorAvatar from './AuthorAvatar';
import PageVisibility from './PageVisibility';
import PageDropDown from './PageDropDown';
import { PageEditButton, SuggestAnEditButton } from './PageEditButton';
import { SharePageButton } from './SharePageWrapper';

import { PageContext } from '../../context/PageContext';
import { hasSuggestEditFeature } from '../../utilities/featureHelper';
import { canCreatePage, canSuggestEdit } from '../../utilities/permissionsUtilities';

const LoadingPageHeader = () => (
    <div className="page-top flex-none mb3">
        <div className="flex-auto flex gray" />
        <div className="flex-none flex no-select mr1 sm-show" style={{ marginTop: 4 }} />
        <div className="flex-none flex no-select" />
        <div className="flex-none no-select" />
    </div>
);

class PageHeader extends React.Component {
    static contextType = PageContext;

    componentDidMount() {
        document.addEventListener('DOMContentLoaded', () => this.forceUpdate());
    }

    componentWillUnmount() {
        document.removeEventListener('DOMContentLoaded', () => this.forceUpdate());
    }

    render() {
        const { page } = this.context;
        if (!page) return <LoadingPageHeader />;
        if (!page.id) return <LoadingPageHeader />;
        const {
            id,
            category_id,
            folder_id,
            parents,
            user_id,
            visibility,
            visibilityTitle,
            authorizationLink,
            can_update,
            slug,
        } = page;

        const showEditButton = can_update || canCreatePage();
        const showSuggestEditButton = hasSuggestEditFeature() && canSuggestEdit();

        return (
            <div className="page-top flex-none">
                <div className="flex-auto flex gray">
                    { category_id && <PageCategoryTitle categoryId={category_id} folderId={folder_id} parents={parents} /> }
                </div>
                <div className="flex-none flex">
                    <div className="flex-none mr1 sm-show" style={{ paddingTop: 3, paddingBottom: 3 }}>
                        <AuthorAvatar
                            userId={user_id}
                            customClass="avatar right"
                            customLinkClass="owner__avatar"
                        />
                    </div>
                    {window.loggedIn && <PageVisibility />}
                    {showEditButton && <PageEditButton can_update={can_update} slug={slug} />}
                    {showSuggestEditButton && <SuggestAnEditButton slug={slug} />}
                    {window.loggedIn && <SharePageButton className="page-action-btn" />}
                    <PageDropDown page={page} isPageShowView />
                </div>
            </div>
        );
    }
}

export default PageHeader;
